import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../../apiClient';
import { FaClock, FaExclamationTriangle, FaArrowRight } from 'react-icons/fa';
import './TrialBanner.css';

function TrialBanner() {
  const [trialStatus, setTrialStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchTrialStatus();
  }, []);

  const fetchTrialStatus = async () => {
    try {
      const response = await apiClient.get('/trial/status');
      setTrialStatus(response.data);
    } catch (error) {
      console.error('Error fetching trial status:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || !trialStatus?.has_trial) {
    return null;
  }

  const { days_remaining, expired, expiring_soon } = trialStatus;

  const getBannerClass = () => {
    if (expired) return 'trial-banner expired';
    if (expiring_soon) return 'trial-banner warning';
    return 'trial-banner';
  };

  const getMessage = () => {
    if (expired) {
      return 'Your trial has expired. Upgrade now to continue using all features.';
    }
    if (days_remaining === 1) {
      return 'Your trial expires tomorrow!';
    }
    if (expiring_soon) {
      return `Only ${days_remaining} days left in your trial.`;
    }
    return `${days_remaining} days remaining in your trial.`;
  };

  const handleUpgradeClick = () => {
    navigate('/settings/subscription');
  };

  return (
    <div className={getBannerClass()}>
      <div className="trial-banner-content">
        <div className="trial-banner-left">
          <span className="trial-banner-icon">
            {expired || expiring_soon ? <FaExclamationTriangle /> : <FaClock />}
          </span>
          <span className="trial-banner-message">{getMessage()}</span>
        </div>
        <button 
          className="trial-banner-button" 
          onClick={handleUpgradeClick}
        >
          Upgrade Now <FaArrowRight />
        </button>
      </div>
    </div>
  );
}

export default TrialBanner;